import './wdyr';
import './devFetchMethodShim';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './sentry';
import './translations';
import './assets/styles/main.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import * as serviceWorker from './serviceWorker';

const container = document.getElementById('app');
const root = createRoot(container);
const match = window.location.pathname.match(/^\/\d{1,3}\.\d{1,3}/);

root.render(
  // TODO: re-enable strict mode
  // <React.StrictMode>
  <BrowserRouter basename={match?.[0] || '/'}>
    <App />
  </BrowserRouter>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(undefined);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// serviceWorker.unregister();
